import Pusher from 'pusher-js';

export const pusherConfig = {
  key: process.env.REACT_APP_PUSHER_KEY,
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
  encrypted: true,
};

export const initializePusher = (myId, userId,token,chanel="") => {

  let sortedIds ;  
   let channelName;

  if(chanel == ""){
   sortedIds  = [myId, userId].sort(); 

   channelName = `private-${sortedIds[0]}-${sortedIds[1]}`;
  }
  else{
   channelName = chanel
  }
  const pusher = new Pusher(pusherConfig.key, {
    cluster: pusherConfig.cluster,
    encrypted: pusherConfig.encrypted,
    authEndpoint: 'https://app.empoweringbeautyau.com/pusher/auth', 
    auth: {
      headers: {
        Authorization: `Bearer ${token}`, 
      },
    },
  });

  const channel = pusher.subscribe(channelName);
  console.log('channel>>>>>>.', channel);
  return { pusher, channel };
};

// export const initializePusher = (myId,userId) => {
//     console.log("kjshfkjad",userId)
//   const pusher = new Pusher(pusherConfig.key, {
//     cluster: pusherConfig.cluster,
//     encrypted: pusherConfig.encrypted,
//   });

//   const channel = pusher.subscribe(`private-${myId}-${userId}`);

//   channel.bind("new-message", (data) => {
//     console.log("New message received:", data);
//   });

//   channel.bind("user-online", (data) => {
//     console.log("User came online:", data);
//   });

//   channel.bind("user-offline", (data) => {
//     console.log("User went offline:", data);
//   });

//   return channel;
// };
